import { Style } from 'inlines'
import { Checkbox } from './Checkbox'

export type CheckboxState = 'checked' | 'unchecked' | 'mixed'

export type TriStateCheckboxProps = {
  state: CheckboxState
  label?: string
  labelPosition?: 'left' | 'right'
  labelSize?: 'medium' | 'small'
  labelStyle?: Style
  disabled?: boolean
  onClick: () => void
}

export const TriStateCheckbox = (props: TriStateCheckboxProps) => {
  const state = props.state
  return (
    <Checkbox
      {...props}
      selected={state === 'checked'}
      inputStyle={{
        '&::after':
          state === 'mixed'
            ? {
                content: `url("data:image/svg+xml,%3Csvg width='16' height='2' viewBox='0 0 16 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 1C0 0.46875 0.4375 0 1 0H15C15.5312 0 16 0.46875 16 1C16 1.5625 15.5312 2 15 2H1C0.4375 2 0 1.5625 0 1Z' fill='rgb(217 217 217)'/%3E%3C/svg%3E%0A");`,
                position: 'absolute',
                top: '45%',
                left: '0.125rem',
                width: '1rem',
                height: '1rem',
                opacity: 1,
              }
            : {},
      }}
    />
  )
}
